import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { useQueryState } from 'nuqs';
import { Tag, Thread } from '@juno/client-api/model';
import PostCard from '../PostCard';
import { ThreadPostSkeleton } from '../styles';

interface SinglePostViewProps {
  singleThread: Thread | undefined;
  onGoBack: () => void;
  refetch: () => void;
  handlePinUnpin: (thread: Thread) => Promise<void>;
  handleTagFilter?: (tag: Tag) => void;
  isInForum?: boolean;
  userCanInteract: boolean;
}
const SinglePostView: React.FC<SinglePostViewProps> = ({
  singleThread,
  onGoBack,
  handlePinUnpin,
  refetch,
  handleTagFilter,
  isInForum = false,
  userCanInteract,
}) => {
  const [threadId] = useQueryState('thread_id', {
    defaultValue: '',
  });
  const [parentThreadId] = useQueryState('parent_thread_id');
  const loadReplies = !!parentThreadId;

  return (
    <>
      <Box mr={2}>
        {!isInForum && (
          <Tooltip title='Back to Feed'>
            <Button variant='text' color='inherit' onClick={onGoBack} startIcon={<ArrowBackIcon />}>
              <Typography variant='body2'>You are viewing a single post.</Typography>
            </Button>
          </Tooltip>
        )}
      </Box>
      {singleThread === undefined || singleThread === null ? (
        <Box>
          <ThreadPostSkeleton />
        </Box>
      ) : (
        <Box my={2}>
          <PostCard
            userCanInteract={userCanInteract}
            isInForum={isInForum}
            handleTagFilter={handleTagFilter}
            thread={singleThread}
            handlePinUnpin={handlePinUnpin}
            refetch={refetch}
            autoScroll
            autoScrollTarget={threadId}
            loadReplies={loadReplies}
          />
        </Box>
      )}
    </>
  );
};
export default SinglePostView;
